meedy.filter('meedyVisibleString', [
    function() {
        return function(input, emptyReplacement) {
            if (input) {
                return input;
            }
            else {
                if (emptyReplacement) {
                    return emptyReplacement;
                }
                else {
                    return '-';
                }
            }
        };
    }
]);